import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { VersionToastInfo } from "@components/VersionToastInfo";
import { APP_VERSION, CHECK_APP_VERSION } from "@config/app";

export function useVersionCheck(interval = 5 * 60 * 1000) {
  useEffect(() => {
    if (!CHECK_APP_VERSION) {
      return;
    }

    const currentVersion = APP_VERSION;

    const checkVersion = async () => {
      try {
        const response = await fetch("/meta.json", { cache: "no-store" });
        const { version: serverVersion } = await response.json();

        if (serverVersion && serverVersion !== currentVersion) {
          toast(<VersionToastInfo />, {
            autoClose: false,
            closeOnClick: false,
            position: "top-center",
            toastId: "update",
            draggable: false,
          });
        }
      } catch (err) {
        console.warn("Błąd sprawdzania wersji:", err);
      }
    };

    // const handleFocus = () => checkVersion();
    // window.addEventListener("focus", handleFocus);

    const intervalId = setInterval(checkVersion, interval);

    return () => {
      // window.removeEventListener("focus", handleFocus);
      clearInterval(intervalId);
    };
  }, [interval]);
}
